import type { ReactNode } from "react";

import { translate } from "app/filters/i18nFilter";
import ResultAssetCell from "app/pages/sales-intelligence/pages/home/components/cells/ResultAssetCell/ResultAssetCell";
import withTooltipCell from "app/pages/sales-intelligence/pages/home/hoc/withTooltipCell";
import { getListTitle } from "app/pages/sales-intelligence/pages/home/utils/lists/getListTitle";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";

import AssetsCountCell from "../../../components/cells/AssetsCountCell/AssetsCountCell";
import { HeaderCellRightAlign } from "../../../components/cells/HeaderCell/HeaderCellRightAlign";
import type { AssetsCountDto } from "../../../types/dto";
import type { CellProps, ListRow } from "../../../types/table";
import { getListTag } from "../../../utils/lists/getListTag";
import createTableColumn from "../base/baseColumnFactory";
import { ACCOUNTS_WITH_SIGNALS_COLUMN, LIST_NAME_COLUMN } from "../columnNames";
import { FIXED_COLUMN_WIDTH } from "../const";

import { createCell } from "./utils";

const fieldToCellMap = {
    [LIST_NAME_COLUMN]: createCell(({ value, ...cellProps }: CellProps<ListRow & { tag: ReactNode }>) => (
        <ResultAssetCell
            className={cellProps.row.iconName}
            tag={getListTag(cellProps.row)}
            value={getListTitle(cellProps.row)}
            {...cellProps}
        />
    )),

    [ACCOUNTS_WITH_SIGNALS_COLUMN]: createCell(({ ...cellProps }: CellProps<ListRow & AssetsCountDto>) => {
        const value = cellProps.value ?? cellProps.row.accountsWithSignalsCount;

        return (
            <AssetsCountCell
                {...cellProps}
                value={value}
            />
        );
    }),
};

export const listsColumns: FlexTableColumnType[] = [
    createTableColumn({
        field: LIST_NAME_COLUMN,
        cellComponent: fieldToCellMap[LIST_NAME_COLUMN],
    }),

    createTableColumn({
        field: ACCOUNTS_WITH_SIGNALS_COLUMN,
        headerComponent: withTooltipCell({
            get tooltipText() {
                return translate("si.pages.home.card.columns.tooltip.accounts-with-signals");
            },
        })(HeaderCellRightAlign),
        cellComponent: fieldToCellMap[ACCOUNTS_WITH_SIGNALS_COLUMN],
        width: FIXED_COLUMN_WIDTH,
    }),
];
